import React from 'react';
import ReactDOM from 'react-dom';
import Avatar from "../Member/Avatar";

export default function Posting(props) {

	const x = props.x;
	const posting = props.posting;
	const postingSelected = (props.selectedPostingNo === posting.postingno && props.mode !== 'list') ? 'posting-selected' : "";
	const postingUnread = (posting.postingno > props.lastPostingRead) ? 'posting-unread' : "";
	const hideContent = (typeof props.hideContent === 'undefined') ? x.was.forumHideContent : props.hideContent;
	const hideDiscussion = (typeof props.hideDiscussion === 'undefined') ? x.was.forumHideDiscussion : props.hideDiscussion;
	const hideAvatar = (typeof props.hideAvatar === 'undefined') ? x.was.forumHideAvatar : props.hideAvatar;
	const hideDate = (typeof props.hideDate === 'undefined') ? x.was.forumHideDate : props.hideDate;
	const hideMember = x.wau.getProperty(props.hideMember, false);

	const [reactionCount, setReactionCount] = React.useState(posting.reactioncount);
	const [reactions, setReactions] = React.useState(posting.reactions);
	const [myReaction, setMyReaction] = React.useState(posting.myreaction);
	const [showReactionPicker, setShowReactionPicker] = React.useState(false);
	const [reactionSmilies, setReactionSmilies] = React.useState(x.was.reactionSmilies);
	const [hoveredReactionCode, setHoveredReactionCode] = React.useState(null);
	const [tooltipStyle, setTooltipStyle] = React.useState(null);
	const reactionTagRef = React.useRef(null);
	const tooltipMaxWidth = 200;

	function showReactionTooltip(e, code) {
		const rect = e.currentTarget.getBoundingClientRect();
		const margin = 8;
		const style = { bottom: window.innerHeight - rect.top + margin };
		if (rect.left + tooltipMaxWidth <= window.innerWidth - margin) {
			style.left = rect.left;
		} else {
			style.right = window.innerWidth - rect.right;
		}
		setTooltipStyle(style);
		setHoveredReactionCode(code);
	}

	function hideReactionTooltip() {
		setHoveredReactionCode(null);
		setTooltipStyle(null);
	}

	function stripTitle(html) {
		return (html || '').replace(/\stitle=(".*?"|'.*?'|[^\s>]+)/i, '');
	}

	React.useEffect(() => {
		setReactionCount(posting.reactioncount);
		setReactions(posting.reactions);
		setMyReaction(posting.myreaction);
	}, [posting.postingno, posting.reactioncount, posting.reactions, posting.myreaction]);

	React.useEffect(() => {
		if (!showReactionPicker) return;
		function handleClickOutside(e) {
			if (reactionTagRef.current && !reactionTagRef.current.contains(e.target)) {
				setShowReactionPicker(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [showReactionPicker]);

	function toggleReactionPicker(e) {
		e.preventDefault();
		if (!showReactionPicker) {
			if (typeof x.was.reactionSmilies === 'undefined') {
				x.was.axGet('Backend/webapp.php?module=Posting&task=SmileyList', (result) => {
					if (result.data['returncode'] === 1) {
						const filtered = result.data['content'].filter(item => item.reaction === 1);
						x.was.reactionSmilies = filtered;
						setReactionSmilies(filtered);
					}
				});
			} else {
				setReactionSmilies(x.was.reactionSmilies);
			}
		}
		setShowReactionPicker(!showReactionPicker);
	}

	function setReaction(code) {
		setShowReactionPicker(false);
		x.was.axPost('Backend/webapp.php?module=Posting&task=SetPostingReaction', { "postingno": posting.postingno, "code": code }, (result) => {
			if (result.data['returncode'] === 1) {
				setReactionCount(result.data['content']['reactioncount']);
				setReactions(result.data['content']['reactions']);
				setMyReaction((myReaction === code) ? null : code);
				x.was.send('new-posting', { "module": props.moduleId, "member": x.was.memberName, "memberlevel": x.was.memberLevel, "postingno": -1 });
			}
		});
	}

	// Diese Variablen werden in makeContent gesetzt
	let content = <></>;
	if (typeof posting.posting !== 'string') {
		// console.log('Posting: ' + posting.posting);
		posting.posting = '';
	}
	// console.log(plainPosting);
	const postingText = x.wau.translatePosting(posting.posting);
	const postingLines = postingText.split("<br />");
	const firstPostingLine = postingLines[0];
	// const oT = (postingLines.length === 1) ? " (oT) " : " ";
	// const title = (posting.visible === 1) ? '<span>' + firstPostingLine + '<i>' + oT + '</i></span>' : '<span>***</span>';

	/*
	const titleTag = 
		<React.Fragment>
			<span>
				<span
					id={props.moduleId + '-' + posting.postingno}
					className="posting-title "
					dangerouslySetInnerHTML={{ __html: title }}
				>
				</span>
			</span>
		</React.Fragment>
	*/


	// console.log(posting.postingno > props.lastPostingRead);
	// console.log(posting.postingno + ' > ' + props.lastPostingRead);

	function makePosting() {
		makeContent();
		const memberLevelLabel = ['', 'Admin', 'Mod', 'User', 'User'];
		const memberLevel = (posting.memberlevel < 3) ? <span className="member-level">{memberLevelLabel[posting.memberlevel]}</span> : ''
		const memberClasses = ['', 'member-name-admin', 'member-name-mod', 'member-name-user', 'member-name-user'];
		const postingInfo = {
			"date": <span
				className={` posting-date ${(hideDate === 1) ? 'd-none' : 'd-inline'} `}
			>
				{posting.postdate}
			</span>,
			"member": <span
				className={` member-name ${memberClasses[posting.memberlevel]}`}
				href="#"
				onClick={
					(props.mode === 'list')
						?
						null
						:
						e => x.wam[props.moduleId].showMemberPostings(posting.memberid, posting.membername)
				}
			>
				{posting.membername}  {memberLevel}
			</span>,
			"iconReply": <i className="bi bi-three-dots" title="Antworten/Reagieren" onClick={e => postingAnswer(e)}></i>,
			"iconReaction": (reactionCount === 0) ? makeReactionAddButton() : null,
			"clipBoard": <i
				className="bi bi-copy"
				title="Beitrag in die Zwischenablage kopieren"
				onClick={e => props.copyToClipboard(e, posting.posting, posting.postdate, posting.membername)}>
			</i>,
			"modified": (posting.modified === 1) ? <i className="bi bi-pencil " /> : null
		};
		switch (props.mode) {
			case 'thread':
				return makeThread(postingInfo);
			case 'answer':
				return makeAnswerTag(postingInfo);
			case 'list':
				return makeList(postingInfo);
			default:
				break;
		}
	}

	function makeContent() {
		content = <></>;
		if (posting.posting !== "" && posting.visible === 1) {
			content =
				<React.Fragment>
					<span
						id={posting.postingno + '-content'}
						className={` posting-content ${(postingLines.length > 10 && ((typeof x.was.postingUnshrink[posting.postingno] === 'undefined') || (x.was.postingUnshrink[posting.postingno] === false))) ? 'posting-shrink' : ''}`}
						dangerouslySetInnerHTML={{ __html: (posting.visible === 1) ? getPosting() : '***' }}
					/>
					{(postingLines.length > 10)
						?
						<span>
							<span
								id={posting.postingno + '-more'}
								className={`bi bi-plus-square posting-content-more ${(typeof x.was.postingUnshrink[posting.postingno] === 'undefined') || (x.was.postingUnshrink[posting.postingno] === false) ? '' : 'd-none'}`}
								title="Kompletten Beitrag anzeigen..."
								onClick={e => togglePostingExpand(e, posting.postingno)}
							/>
							<span
								id={posting.postingno + '-shrink'}
								className={`bi bi-dash-square posting-content-more ${(typeof x.was.postingUnshrink[posting.postingno] === 'undefined') || (x.was.postingUnshrink[posting.postingno] === false) ? 'd-none' : ''}`}
								title="Vorschau anzeigen..."
								onClick={e => togglePostingExpand(e, posting.postingno)}
							/>
						</span>

						:
						null
					}
				</React.Fragment>
		}
		else {
			content = <span>***</span>;
		}
	}

	function togglePostingExpand(event, postingNo) {
		event.preventDefault();
		const postingId = postingNo + '-content';
		const posting = document.getElementById(postingId);
		const more = document.getElementById(postingNo + '-more');
		const shrink = document.getElementById(postingNo + '-shrink');

		if ((typeof x.was.postingUnshrink[postingNo] === 'undefined') || (x.was.postingUnshrink[postingNo] === false)) {
			x.was.postingUnshrink[postingNo] = true;
			posting.classList.remove('posting-shrink');
			more.classList.add('d-none');
			shrink.classList.remove('d-none');
		}
		else {
			x.was.postingUnshrink[postingNo] = false;
			posting.classList.add('posting-shrink');
			more.classList.remove('d-none');
			shrink.classList.add('d-none');
		}
	}

	function getPosting() {
		if (hideContent === 1) {
			return firstPostingLine;
		}
		else {
			// let posting = firstPostingLines.join('<br />');
			return postingText;
		}
	}

	function makeThread(postingInfo) {
		return ((hideAvatar) ? makeThreadTag(postingInfo) : makeThreadTagAvatar(postingInfo));
	}

	function makeTopic() {
		const topic = <span
			className="posting-topic"
			onClick={(e) => {
				props.setTopic(posting.topicid, posting.topicname);
			}}
		>
			{posting.topicname}
		</span>

		return topic;

	}

	function makeThreadTag(postingInfo) {
		const topic = makeTopic();
		const memberTag =
			<div className='posting-head d-flex'>
				<div >
					{postingInfo.member}
				</div>
				{postingInfo.date}
				<span>
					{(posting.topicname !== '') ? topic : null}
				</span>
				{postingInfo.iconReply}
				{postingInfo.iconReaction}
			</div>;

		return (
			<div key={posting.postingno} className={`postings ${postingUnread}`} >
				<div className="thread thread-no-avatar">
					<div>
						{memberTag}
						<div >
							{postingInfo.modified} {content}
						</div>
						{makeReactionBar()}
					</div>
				</div>
			</div>
		);
	}

	function makeThreadTagAvatar(postingInfo) {
		const image = posting.avatarimage;
		const avatar = <Avatar
			memberLevel={posting.memberlevel}
			avatarText={posting.membername}

			image={image}
			onClick={(e, avatar) => {
				if (avatar) {
					x.wam.openProfile(posting.memberid, posting.membername)
				}
				else {
					x.wam[props.moduleId].showMemberPostings(posting.memberid, posting.membername);
				}
			}}
		/>;
		const topic = makeTopic();

		const memberTag =
			<div className='posting-head d-flex'>
				<div >
					{postingInfo.member}
				</div>
				{postingInfo.date}
				<span>
					{(posting.topicname !== '') ? topic : null}
				</span>
				{postingInfo.iconReply}
				{postingInfo.iconReaction}
			</div>;

		return (
			<div key={posting.postingno} className={`postings ${postingUnread}`} >
				<div className="thread">
					{avatar}
					<div>
						{memberTag}
						<div >
							{postingInfo.modified}{content}
						</div>
						{makeReactionBar()}
					</div>
				</div>
			</div>
		);

	}

	function makeAnswerTag(postingInfo) {
		return (
			<div key={posting.postingno}
				className={` postings ${(hideDiscussion === 1) ? 'd-none' : 'd-block'} ${postingUnread}`}
				style={{ paddingLeft: ''.concat(props.paddingLeft + (posting.threadcodepos * 10)).concat('px') }}
			>
				<div >
					<span className={`answer align-text-bottom`} >
						{postingInfo.member}
						{postingInfo.date}
						{postingInfo.iconReply}
						{postingInfo.iconReaction}
					</span>
					<div id={'content-' + posting.postingno} className={` answer-content `} >
						{postingInfo.modified}{content}
					</div>
					{makeReactionBar()}
				</div>
			</div>
		)
	}

	function makeList(postingInfo) {
		return (
			<div key={posting.postingno}
				className={` ${(hideDiscussion === 1) ? 'd-none' : 'd-block'} `}
				style={{ paddingLeft: ''.concat(props.paddingLeft + (posting.threadcodepos * 10)).concat('px') }}
			>
				<div >
					<span className={`answer align-text-bottom`} >
						<span onClick={props.onClick}>
							{(hideMember) ? null : postingInfo.member}
							{postingInfo.date}
						</span>
						{postingInfo.iconReply}
						{postingInfo.clipBoard}<br />
					</span>
					<div id={'content-' + posting.postingno} className={` answer-content posting-list-content`} onClick={props.onClick} >
						{content}
					</div>
				</div>
			</div>
		)
	}

	function makeReactionTitle(members) {
		if (!members || members.length === 0) return '';
		const names = members.map(name => (name === x.was.memberName) ? 'Sie' : name);
		let namesText;
		if (names.length === 1) {
			namesText = names[0];
		} else {
			namesText = names.slice(0, -1).join(', ') + ' und ' + names[names.length - 1];
		}
		const verb = (names.length === 1 && names[0] !== 'Sie') ? 'hat' : 'haben';
		return `${namesText} ${verb} reagiert`;
	}

	function makeReactionAddButton() {
		return (
			<span className="reaction-add-pill" title="Reagieren" ref={reactionTagRef} onClick={e => toggleReactionPicker(e)}>
				<i className="bi bi-emoji-smile" />
				{(showReactionPicker) ? makeReactionPicker() : null}
			</span>
		);
	}

	function makeReactionBar() {
		if (reactionCount === 0) {
			return null;
		}
		return (
			<div className="reaction-bar">
				{Object.entries(reactions || {}).filter(([, info]) => info.count > 0).map(([code, info]) => (
					<span
						key={code}
						className={`reaction-pill ${(myReaction === code) ? 'reaction-pill-mine' : ''}`}
						onClick={e => { e.preventDefault(); setReaction(code); }}
						onMouseEnter={e => showReactionTooltip(e, code)}
						onMouseLeave={hideReactionTooltip}
					>
						<span className="reaction-pill-smiley" dangerouslySetInnerHTML={{ __html: (x.was.smilies[code]) ? stripTitle(x.was.smilies[code]) : code }} />
						<span className="reaction-pill-count">{info.count}</span>
						{(hoveredReactionCode === code && tooltipStyle)
							?
							ReactDOM.createPortal(
								<span className="reaction-tooltip" style={{ ...tooltipStyle, maxWidth: tooltipMaxWidth }}>
									{makeReactionTitle(info.members)}
								</span>,
								document.getElementById('webapp') || document.body
							)
							:
							null
						}
					</span>
				))}
				<span className="reaction-add-pill" title="Reagieren" ref={reactionTagRef} onClick={e => toggleReactionPicker(e)}>
					<i className="bi bi-emoji-smile" />
					{(showReactionPicker) ? makeReactionPicker() : null}
				</span>
			</div>
		);
	}

	function makeReactionPicker() {
		return (
			<span className="reaction-picker">
				<i className="bi bi-x reaction-picker-close" title="Schließen" onClick={e => { e.preventDefault(); setShowReactionPicker(false); }} />
				{(reactionSmilies || []).map((item) => (
					<span
						key={item.code}
						className={`reaction-picker-item ${(myReaction === item.code) ? 'reaction-picker-item-selected' : ''}`}
						title={item.code}
						onClick={e => { e.preventDefault(); setReaction(item.code); }}
						dangerouslySetInnerHTML={{ __html: item.smiley }}
					/>
				))}
			</span>
		);
	}

	function postingAnswer(e) {
		e.preventDefault();
		props.showDialogAnswer(props.getPostings, posting.topicid, posting.topicname, posting.postingno, posting.visible, posting.posting, posting.memberid, posting.membername, posting.postdate);
	}

	return (
		<span id={"posting-" + ((props.mode === 'list') ? "list-" : "") + props.id} postingno={posting.postingno} key={"posting-" + posting.postingno} className={` ${postingSelected} `}>
			{makePosting()}
		</span>
	)
};
